// @ts-nocheck
/* eslint-disable */

import * as Types from '../../../graphql/v3/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DebtWarningQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DebtWarningQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: number, balance: number, debtLevel?: Types.DebtLevels | null } };


export const DebtWarningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DebtWarning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"debtLevel"}}]}}]}}]} as unknown as DocumentNode;
export function useDebtWarningQuery(baseOptions?: Apollo.QueryHookOptions<DebtWarningQuery, DebtWarningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebtWarningQuery, DebtWarningQueryVariables>(DebtWarningDocument, options);
      }
export function useDebtWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebtWarningQuery, DebtWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebtWarningQuery, DebtWarningQueryVariables>(DebtWarningDocument, options);
        }
export function useDebtWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebtWarningQuery, DebtWarningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebtWarningQuery, DebtWarningQueryVariables>(DebtWarningDocument, options);
        }
export type DebtWarningQueryHookResult = ReturnType<typeof useDebtWarningQuery>;
export type DebtWarningLazyQueryHookResult = ReturnType<typeof useDebtWarningLazyQuery>;
export type DebtWarningSuspenseQueryHookResult = ReturnType<typeof useDebtWarningSuspenseQuery>;